module.exports = __webpack_public_path__ + "static/media/awoolplanet_htu06.14c59a6d.gif";